import React, { useEffect } from 'react';
import { useFormik } from 'formik';

import {
    useCreateWelcomeMessageMutation,
    useReadWelcomeMessageQuery,
} from '../service/bot';
import { createFormData } from '../../../../../utils/common/createFormData';
import { Save } from '../../../widgets/Save';
import { initialValues } from '../utils/options';
import { WelcomeMessageForm } from '../components/WelcomeMessageForm';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

export const WelcomeMessageContainer = () => {
    const current = useAppSelector(selectShopCurrent);

    const [createWelcomeMessage, { isLoading }] =
        useCreateWelcomeMessageMutation();
    const { data, isSuccess } = useReadWelcomeMessageQuery(current.id);

    useEffect(() => {
        if (isSuccess && data) {
            formik.setValues({ ...data });
        }
    }, [isSuccess, data]);
    const onSave = async () => {
        await createWelcomeMessage({
            id: current.id,
            body: createFormData(formik.values),
        });
    };

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: onSave,
    });

    return (
        <div>
            <WelcomeMessageForm formik={formik} />
            <Save loading={isLoading} disabled={isLoading} onSave={onSave} />
        </div>
    );
};
